import { z } from 'zod';
import { httpUrl, slug, stateCode } from './common.js';
import { propertyKind, propertyStage, propertyStatus, propertyType } from './enums.js';
import { geoPoint, priceRange, propertySpecs, unitType } from './property.js';

// POST /broker/properties · broker creates one of their own properties.
export const createPropertyInput = z
  .object({
    name: z.string().trim().min(2).max(120),
    slug: slug,
    tagline: z.string().trim().max(140).optional(),
    developer: z.string().trim().max(120).optional(),
    description: z.string().max(4000).optional(),
    city: z.string().trim().min(2).max(80),
    state: stateCode,
    neighborhood: z.string().trim().min(2).max(80).optional(),
    location: geoPoint.optional(),
    /** null = sem preço divulgado (o corretor limpou). */
    priceRange: priceRange.nullable().optional(),
    unitTypes: z.array(unitType).max(20).default([]),
    photos: z.array(httpUrl).max(30).default([]),
    features: z.array(z.string().trim().min(1).max(60)).max(40).default([]),
    stage: propertyStage.nullable().optional(),
    kind: propertyKind.optional(),
    propertyType: propertyType.nullable().optional(),
    specs: propertySpecs.optional(),
    referenceCode: z.string().trim().max(30).optional(),
    featured: z.boolean().optional(),
    status: propertyStatus.default('draft'),
  })
  .strict();

export type CreatePropertyInput = z.infer<typeof createPropertyInput>;

export const updatePropertyInput = createPropertyInput.partial();
export type UpdatePropertyInput = z.infer<typeof updatePropertyInput>;
